import React from 'react';
import { Popover } from '@festo-ui/react';

interface InfoButtonPopupProps {
  children: React.ReactNode;
  className: string;
}

function InfoButtonPopup({ children }: InfoButtonPopupProps) {
  return (
    <Popover popoverContent={children} className="fr-info-button" position={'right'}>
      <span className="facet-field__inline-icon fwe-icon fwe-icon-status-info" />
    </Popover>
  );
}

export default InfoButtonPopup;
